import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Hero from './components/Hero';
import FeatureSection from './components/FeatureSection';
import CTASection from './components/CTASection';
import TestimonialsSection from './components/TestimonialsSection';
import BlogSection from './components/BlogSection';
import Footer from './components/Footer';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import BlogPost1 from './pages/BlogPost1';
import BlogPost2 from './pages/BlogPost2';
import BlogPost3 from './pages/BlogPost3';

function App() {
  return (
    <div className="bg-[#0A0A0A] text-gray-200 font-sans min-h-screen">
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero />
              <FeatureSection />
              <CTASection />
              <TestimonialsSection />
              <BlogSection />
              <Footer />
            </>
          }
        />
        <Route path="/blog/creative-challenges" element={<BlogPost1 />} />
        <Route path="/blog/responsible-bantr" element={<BlogPost2 />} />
        <Route path="/blog/supercharge-rivalries" element={<BlogPost3 />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
    </div>
  );
}

export default App;
